<script setup lang="ts">
/**
 * Final Dividends — Cover Letter to Member (Sole Corporate Member).
 *   원본: Cover Letter to Member – Final Dividends (Sole Corporate Member).
 *   서명 = 이사 1인([[Signing_Director_Signature]]).
 */
import CddVarField from '../cdd/CddVarField.vue';
import AgmSigners from '../cdd/AgmSigners.vue';
import './agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div><b><CddVarField field-key="company_name" label="Company Name" /></b></div>
      <div>Company Registration No. <CddVarField field-key="company_registration_no" label="Reg No" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the &ldquo;Company&rdquo;)</div>
      <div>Registered Office: <CddVarField field-key="registered_office_address" label="Registered Office Address" /></div>
    </div>

    <p class="doc-p">Date: <CddVarField field-key="letter_date" label="Letter Date" /></p>
    <p class="doc-p">
      <CddVarField field-key="member_name" label="Member Name" /><br />
      <CddVarField field-key="member_address" label="Member Address" />
    </p>
    <p class="doc-p">Dear Sirs,</p>
    <p class="doc-p"><b><CddVarField field-key="company_name" label="Company Name" /> (the &ldquo;Company&rdquo;)</b><br />- Member&rsquo;s Resolutions In Writing</p>

    <p class="doc-p">Please find enclosed for your attention:-</p>
    <p class="doc-p indent">
      notice from the directors of the Company seeking your agreement as a member of the Company to a member&rsquo;s resolutions in writing
      pursuant to the Constitution of the Company and Section 184A of the Companies Act 1967 of Singapore; and
    </p>
    <p class="doc-p indent">member&rsquo;s resolutions in writing.</p>
    <p class="doc-p">
      If you agree to the resolutions set out in the Member&rsquo;s Resolutions in Writing, please sign, or arrange for your duly appointed
      representative to sign, the said resolutions and return it to us.
    </p>

    <p class="doc-p">Yours faithfully</p>
    <div class="sign-block">
      <AgmSigners var-key="signing_director_Signers" board-label="Director" />
    </div>

    <p class="doc-p">Enclosure(s)</p>
    <p class="doc-p indent">- Notice from the directors of the Company</p>
    <p class="doc-p indent">- Member&rsquo;s resolutions in writing</p>
  </div>
</template>
